// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { BridgeUserAgreement } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Agreement/User/module';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useTerminateBridgeUserAgreement: () => UseMutationResult<
  void,
  string,
  {
    bridgeUserAgreementCid: ContractId<BridgeUserAgreement>;
    reason: string;
    actor: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['terminateBridgeUserAgreement', ledgerApi],
    mutationFn: async ({ bridgeUserAgreementCid, reason, actor }) => {
      return ledgerApi.terminateBridgeUserAgreement(bridgeUserAgreementCid, reason, actor);
    },
  });
};

export default useTerminateBridgeUserAgreement;
